function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 8,
  fill: "#30C24D"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.101 31.546L9 39l7.695-1.979a14.973 14.973 0 007.324 1.908C32.28 38.929 39 32.216 39 23.964 39 15.714 32.28 9 24.02 9 15.758 9 9.038 15.713 9.038 23.965c0 2.68.711 5.288 2.062 7.58zm6.446 3.032l-.458-.28-4.446 1.144 1.21-4.293-.309-.48a12.372 12.372 0 01-1.964-6.704c0-6.852 5.58-12.426 12.44-12.426 6.858 0 12.439 5.574 12.439 12.426 0 6.851-5.58 12.426-12.44 12.426-2.29 0-4.528-.627-6.471-1.813zm1.292-17.631l.972.053c.191.01.36.128.436.304l1.416 3.31a.503.503 0 01-.082.526l-1.233 1.425a.372.372 0 00-.047.415c1.624 3.124 4.582 4.362 5.465 4.672a.37.37 0 00.415-.124l1.29-1.67a.504.504 0 01.61-.15l3.285 1.513a.503.503 0 01.281.563l-.155.724a3.135 3.135 0 01-1.365 1.99c-.89.568-2.043.847-3.509.433-4.55-1.285-7.122-4.293-8.502-6.174-1.38-1.88-1.914-3.76-1.569-5.296.232-1.03.985-1.82 1.456-2.229.231-.2.53-.302.836-.285z",
  fill: "#fff"
});

var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgWhatsapp;